import { checkPostalCode } from "../../util/helper/checkPostalCode";

export default function getCanadaProvince(zipCode: string) {
  const zip = zipCode ? zipCode.toUpperCase() : null;
  const YUKON = "YT";
  const NUNAVUT = "NU";
  const BRITISH_COLUMBIA = "BC";
  const ALBERTA = "AB";
  const SASKATCHEWAN = "SK";
  const MANITOBA = "MB";
  const ONTARIO = "ON";
  const QUEBEC = "QC";
  const NEW_BRUNSWICK = "NB";
  const PRINCE_EDWARD_ISLAND = "PE";
  const NOVA_SCOTIA = "NS";
  const NEWFOUNDLAND_LABRADOR = "NL";
  const NORTHWEST_TERRITORIES = "NT";

  if (checkPostalCode(zip)) {
    if (zip.startsWith("Y")) {
      return YUKON;
    } if (zip.startsWith("X")) {
      if (zip.startsWith("X0A") || zip.startsWith("X0B") || zip.startsWith("X0C")) {
        return NUNAVUT;
      }
      return NORTHWEST_TERRITORIES;
    } if (zip.startsWith("V")) {
      return BRITISH_COLUMBIA;
    } if (zip.startsWith("T")) {
      return ALBERTA;
    } if (zip.startsWith("S")) {
      return SASKATCHEWAN;
    } if (zip.startsWith("R")) {
      return MANITOBA;
    } if (zip.startsWith("P") || zip.startsWith("N") || zip.startsWith("M") || zip.startsWith("L") || zip.startsWith("K")) {
      return ONTARIO;
    } if (zip.startsWith("J") || zip.startsWith("H") || zip.startsWith("G")) {
      return QUEBEC;
    } if (zip.startsWith("E")) {
      return NEW_BRUNSWICK;
    } if (zip.startsWith("C")) {
      return PRINCE_EDWARD_ISLAND;
    } if (zip.startsWith("B")) {
      return NOVA_SCOTIA;
    } if (zip.startsWith("A")) {
      return NEWFOUNDLAND_LABRADOR;
    }
    return null;
  }
  return null;
}
